import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#7540ee",
      d: "M17.25 8.397v-.522c0-2.351-3.547-4.125-8.25-4.125S.75 5.524.75 7.875v3.75c0 1.958 2.46 3.515 6 3.98v.52c0 2.351 3.547 4.125 8.25 4.125s8.25-1.774 8.25-4.125v-3.75c0-1.94-2.383-3.499-6-3.978m4.5 3.978C21.75 13.615 18.863 15 15 15q-.525 0-1.039-.035c2.022-.737 3.289-1.934 3.289-3.34V9.913c2.8.417 4.5 1.55 4.5 2.462m-15 1.71v-2.23A17 17 0 0 0 9 12a17 17 0 0 0 2.25-.144v2.23q-1.119.165-2.25.164-1.131 0-2.25-.164m9-3.78v1.32c0 .787-1.163 1.631-3 2.144v-2.19c1.21-.294 2.235-.731 3-1.273M9 5.25c3.863 0 6.75 1.386 6.75 2.625S12.863 10.5 9 10.5 2.25 9.114 2.25 7.875 5.137 5.25 9 5.25m-6.75 6.375v-1.32c.765.543 1.79.98 3 1.273v2.191c-1.837-.513-3-1.357-3-2.144m6 4.5v-.39q.37.014.75.015.546 0 1.068-.033.581.209 1.182.353v2.2c-1.837-.514-3-1.358-3-2.145m4.5 2.46V16.35q1.12.15 2.25.15a17 17 0 0 0 2.25-.144v2.23a15.5 15.5 0 0 1-4.5 0m6-.316v-2.19c1.21-.294 2.235-.731 3-1.273v1.319c0 .787-1.163 1.631-3 2.144"
    }, null, -1)
  ]))]))
}
export default { render: render }